import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Field, reduxForm } from 'redux-form';
import {
  Button,
  Grid,
  Row
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

//Translations
import { injectIntl, FormattedMessage } from 'react-intl';

import Link from '../../Link';
//common fields
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import HeaderModal from '../../HeaderModal/HeaderModal';

import { openHeaderModal } from '../../../actions/modalActions';
import { formatLocale } from '../../../helpers/formatLocale';
import messages from '../../../locale/jsonMessages';
import submit from './submit';
import validate from './validate';
import { photosShow } from '../../../helpers/photosShow';
import { logouploadDir } from '../../../config';

//Images
import adminLoginImage from '/public/siteImages/siteLoginImage.svg';
import arrowIcon from '/public/SiteIcons/letGoIcon.svg';
import goIcon from '/public/SiteIcons/goSiteIcon.svg';
import languageIcon from '/public/SiteIcons/languageChangeIcon.svg';

import cs from '../../../components/commonStyle.css';
import s from './AdminLoginForm.css';


class AdminLoginForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true
    }
  }

  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    isBrowser && this.setState({
      isDisabled: false
    });
  }


  render() {
    const { error, handleSubmit, submitting, dispatch, siteSettingsData, currentLocale, openHeaderModal } = this.props;
    const { formatMessage } = this.props.intl;
    const title = (
      <h2>{formatMessage(messages.adminLogInLabel)}</h2>
    );
    let path = photosShow(logouploadDir);
    let adminLogo = siteSettingsData?.Logo && `${path}${siteSettingsData.Logo}`;

    return (
      <div >
        <HeaderModal hideCurrencyModal={true} />
        <Grid fluid>
          <Row>
            <div className={s.loginMainBg}>
              <div className={s.bgColor}><div className={s.loginBg} style={{ backgroundImage: `url(${adminLoginImage})` }} /></div>
              <div>
                <div className={cx(cs.dFlexWrapAlignEnd, s.topPadding, s.mobileWrap)}>
                  <Link to="/" className={cx(cs.dFlex, s.twoPadding)}>
                    <img src={goIcon} className={'iconGap'} />
                    <span className={cx(cs.commonContentText, cs.fontWeightMedium, cs.reviewHeadingColor)}><FormattedMessage {...messages.GotoMainSite} /></span>
                  </Link>
                  <Link>
                    <div onClick={(e) => openHeaderModal('languageModal')} className={cs.dFlex}>
                      <img src={languageIcon} className={'iconGap'} />
                      <span className={cx(cs.commonContentText, cs.fontWeightMedium, cs.reviewHeadingColor)}>
                        {formatLocale(currentLocale)}
                      </span>
                    </div>
                  </Link>
                </div>
                <div className={s.formInner}>
                  <div className={s.loginTitleScetion}>
                    {
                      adminLogo ?
                        <img src={adminLogo} />
                        :
                        <div className={s.siteNameCss}>{siteSettingsData.siteName}</div>
                    }
                    <p className={s.loginTitle}>{formatMessage(messages.welcomeAdminLabel)}</p>
                  </div>
                  <form onSubmit={handleSubmit(submit)}>
                    {error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
                    <div className="oneColumnGrid">
                      <Field
                        name="email"
                        type="text"
                        component={CommonFormComponent}
                        inputClass='commonInputField'
                        placeholder={formatMessage(messages.enterTheEmailAddress)}
                        labelText={formatMessage(messages.emailLabel)}
                        isRequiredInput
                      />

                      <Field
                        name="password"
                        type="password"
                        component={CommonFormComponent}
                        inputClass='commonInputField'
                        placeholder={formatMessage(messages.enterYourPassword)}
                        labelText={formatMessage(messages.password)}
                        isRequiredInput
                      />
                    </div>
                    <div className={cx(s.spaceTop5)}>
                      <Button className={cx(cs.btnPrimary, cs.fullWidth, s.loginbtn, cs.dInlineFlex, cs.justifyCenter)} type="submit" disabled={submitting || this.state.isDisabled}>
                        <FormattedMessage {...messages.logInLabel} />
                        <img src={arrowIcon} className={cx(s.arrowIconCss, 'sliderArrowRTL')} />
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Row>
        </Grid>
      </div>
    )
  }

}
const mapState = (state) => ({
  siteSettingsData: state.siteSettings.data,
  currentLocale: state.intl.locale
});

const mapDispatch = {
  openHeaderModal
};

AdminLoginForm = reduxForm({
  form: 'AdminLoginForm', // a unique name for this form
  validate
})(AdminLoginForm);

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(AdminLoginForm)));